import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import Login from '../../components/login/login';

const Authentication = ({
  requiresAuth,
  authRoleRequired,
  onSuccess,
  isSignedIn,
  loginModalImgOverride,
  loginModalCopyOverride,
  loginPageCopyOverride,
  roles,
  children,
}) => {
  const isEmployee = _.includes(roles, 'nerdwallet/employee');
  const hasAuth = isEmployee || _.includes(roles, `${authRoleRequired}`);

  return requiresAuth && !hasAuth ? (
    <Login
      onSuccess={onSuccess}
      isSignedIn={isSignedIn}
      loginModalImgOverride={loginModalImgOverride}
      loginModalCopyOverride={loginModalCopyOverride}
      loginPageCopyOverride={loginPageCopyOverride}
    />
  ) : (
    children
  );
};

Authentication.propTypes = {
  requiresAuth: PropTypes.bool,
  authRoleRequired: PropTypes.string,
  onSuccess: PropTypes.string,
  isSignedIn: PropTypes.bool,
  loginModalImgOverride: PropTypes.string,
  loginModalCopyOverride: PropTypes.string,
  loginPageCopyOverride: PropTypes.string,
  roles: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
};

const AuthenticationWrapped = connect((state) => ({
  isSignedIn: _.get(state, 'identity.isSignedIn', false),
  roles: _.get(state, 'identity.current.roles'),
}))(Authentication);

AuthenticationWrapped.displayName = 'Wrapped Authentication';

export default AuthenticationWrapped;
